module.exports = __webpack_public_path__ + "img/my-booking.1e89aa7e.png";